<ng-container *ngrxLet="sharedService.startTourObs$ as isTourOn">
  <div
    class="page-header-menu topnavsfixed"
    [style.pointer-events]="(isTourOn?.length ? isTourOn[0] : isTourOn) ? 'none' : 'auto'"
  >
    <nav class="navbar navbar-light nav-light navbar-expand-xl w-100">
      <div class="container-fluid container-alignment">
        <div class="logo page-logo">
          <a href="/Home/Index" routerLink="/dashboard"
            ><img width="80" height="80" src="assets/images/Piqet_NewLogo.svg" alt="Piqet"
          /></a>
        </div>
        <button
          (click)="toggleCollapsed()"
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div
          class="collapse navbar-collapse"
          id="navbarNav"
          [ngClass]="{ collapse: collapsed, 'navbar-collapse': true }"
        >
          <ul class="menu-main navbar-nav mt-2 mt-lg-0 ms-auto">
            <ng-container *ngFor="let menu of menuItems; let index = index">
              <li *ngIf="menu.isAccess" class="nav-item" routerLinkActive="active">
                <a
                  [style.pointer-events]="
                    (menu.submenu && !menu.hideForNav) ||
                    (isTourOn?.length ? isTourOn[0] : isTourOn)
                      ? 'none'
                      : 'auto'
                  "
                  routerLink="{{ menu.link }}"
                  class="menutext no-link"
                >
                  <span>{{ menu.text }}</span
                  ><i
                    class="fa fa-angle-down chevron-i"
                    *ngIf="menu.submenu && !menu.hideForNav"
                  ></i>
                </a>
                <ul class="menu-sub" *ngIf="menu.submenu && !menu.hideForNav">
                  <ng-container *ngFor="let submenu of menu.submenu">
                    <li
                      *ngIf="submenu.isAccess"
                      routerLinkActive="active"
                      [class.feature-locked-item]="submenu.isFeatureLocked"
                    >
                      <!-- Feature Lock Wrapper for locked items -->
                      <app-feature-lock
                        *ngIf="submenu.isFeatureLocked"
                        [featureCode]="submenu.featureCode"
                        [isDisabled]="true"
                        [popupPosition]="index < 2 ? 'right' : 'left'"
                        [showProBadge]="false"
                      >
                        <a
                          class="dropdown-item iconify no-link no-gradient"
                          href="#"
                          (click)="
                            $event.preventDefault(); onSubMenuItemClick(submenu.text, submenu)
                          "
                        >
                          <i
                            *ngIf="submenu.submenu"
                            [class]="
                              index === menuItems.length - 1 || index === menuItems.length - 2
                                ? 'fa fa-angle-left left-icon'
                                : 'fa fa-angle-right right-icon'
                            "
                          >
                          </i>
                          <span class="menu-text-with-icon">
                            {{ submenu.text }}
                            <app-crown-icon [size]="14" [tooltip]="''"> </app-crown-icon>
                          </span>
                        </a>
                      </app-feature-lock>

                      <!-- Regular menu items (not locked) -->
                      <ng-container *ngIf="!submenu.isFeatureLocked">
                        <ng-container
                          *ngIf="!submenu.text.toLowerCase().includes('tour'); else dashboard"
                        >
                          <a
                            class="dropdown-item iconify no-link"
                            href="#"
                            (click)="onSubMenuItemClick(submenu.text, submenu)"
                            [style.pointer-events]="
                              submenu.submenu || (isTourOn?.length ? isTourOn[0] : isTourOn)
                                ? 'none'
                                : 'auto'
                            "
                            routerLink="{{ submenu.link }}"
                            routerLinkActive="cssClassName"
                          >
                            <i
                              *ngIf="submenu.submenu"
                              [class]="
                                index === menuItems.length - 1 || index === menuItems.length - 2
                                  ? 'fa fa-angle-left left-icon'
                                  : 'fa fa-angle-right right-icon'
                              "
                            >
                            </i>
                            {{ submenu.text }}
                          </a>
                        </ng-container>
                        <ng-template #dashboard>
                          <button
                            class="dropdown-item iconify"
                            [style.pointer-events]="
                              submenu.submenu || (isTourOn?.length ? isTourOn[0] : isTourOn)
                                ? 'none'
                                : 'auto'
                            "
                          >
                            <i class="fa fa-angle-left left-icon guide-tour"> </i>{{ submenu.text }}
                          </button>
                        </ng-template>
                      </ng-container>

                      <div class="dropdown-divider"></div>

                      <!-- Second level submenu -->
                      <ul
                        class="menu-sub-l2"
                        *ngIf="submenu.submenu && !submenu.isFeatureLocked"
                        [ngStyle]="{
                          right:
                            index === menuItems.length - 1 || index === menuItems.length - 2
                              ? '100%'
                              : 'unset',
                          left:
                            index === menuItems.length - 1 || index === menuItems.length - 2
                              ? 'unset'
                              : '100%'
                        }"
                      >
                        <ng-container *ngFor="let childmenu of submenu.submenu">
                          <li
                            *ngIf="childmenu.isAccess"
                            routerLinkActive="active"
                            [class.feature-locked-item]="childmenu.isFeatureLocked"
                          >
                            <!-- Feature locked child menu -->
                            <app-feature-lock
                              *ngIf="childmenu.isFeatureLocked"
                              [featureCode]="childmenu.featureCode"
                              [isDisabled]="true"
                              [popupPosition]="'left'"
                              [showProBadge]="false"
                            >
                              <div class="mega-menu-content">
                                <div class="row">
                                  <div class="col-md-12">
                                    <ul class="mega-menu-submenu">
                                      <li>
                                        <a
                                          class="dropdown-item iconify no-link no-gradient"
                                          href="#"
                                          (click)="
                                            $event.preventDefault();
                                            onSubMenuItemClick(childmenu.text, childmenu)
                                          "
                                        >
                                          <span class="menu-text-with-icon">
                                            {{ childmenu.text }}
                                            <app-crown-icon [size]="14" [tooltip]="''">
                                            </app-crown-icon>
                                          </span>
                                        </a>
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </app-feature-lock>

                            <!-- Regular child menu -->
                            <div class="mega-menu-content" *ngIf="!childmenu.isFeatureLocked">
                              <div class="row">
                                <div class="col-md-12">
                                  <ul class="mega-menu-submenu">
                                    <li
                                      [title]="
                                        childmenu.text.toLowerCase() ===
                                          'advanced reporting tour' && !isAdvancedTourEnabled
                                          ? 'This feature is not available in your current plan'
                                          : ''
                                      "
                                    >
                                      <!-- Feature Lock for Advanced Reporting Tour -->
                                      <app-feature-lock
                                        *ngIf="
                                          childmenu.text.toLowerCase() ===
                                            'advanced reporting tour' && !isAdvancedTourEnabled
                                        "
                                        [featureCode]="FeatureCodes.HELP_ADVANCED_GUIDED_TOUR"
                                        [isDisabled]="true"
                                        [popupPosition]="'bottom-left'"
                                      >
                                        <a
                                          class="dropdown-item iconify no-link disabled-menu-item no-gradient"
                                          href="javascript:void(0)"
                                          (click)="
                                            $event.preventDefault(); $event.stopPropagation()
                                          "
                                        >
                                          <i
                                            *ngIf="childmenu.submenu"
                                            [class]="
                                              index === menuItems.length - 1 ||
                                              index === menuItems.length - 2
                                                ? 'fa fa-angle-left left-icon'
                                                : 'fa fa-angle-right right-icon'
                                            "
                                          >
                                          </i>
                                          <span class="menu-text">
                                            {{ childmenu.text }}
                                          </span>
                                          <app-crown-icon
                                            [size]="14"
                                            [showBadge]="false"
                                            [customClass]="'menu-crown-icon'"
                                          >
                                          </app-crown-icon>
                                        </a>
                                      </app-feature-lock>

                                      <!-- Regular menu items (not locked) -->
                                      <ng-container
                                        *ngIf="
                                          childmenu.text.toLowerCase() !==
                                            'advanced reporting tour' || isAdvancedTourEnabled
                                        "
                                      >
                                        <a
                                          *ngIf="
                                            getStaticAssetUrl(childmenu) as pdfUrl;
                                            else childmenuRouterAnchor
                                          "
                                          class="dropdown-item iconify no-link"
                                          [href]="pdfUrl"
                                          target="_blank"
                                          rel="noopener"
                                        >
                                          <i
                                            *ngIf="childmenu.submenu"
                                            [class]="
                                              index === menuItems.length - 1 ||
                                              index === menuItems.length - 2
                                                ? 'fa fa-angle-left left-icon'
                                                : 'fa fa-angle-right right-icon'
                                            "
                                          >
                                          </i>
                                          {{ childmenu.text }}
                                        </a>
                                        <ng-template #childmenuRouterAnchor>
                                          <a
                                            class="dropdown-item iconify no-link"
                                            href="#"
                                            routerLink="{{ childmenu.link }}"
                                            (click)="OnGuidetour(childmenu.text)"
                                            [style.pointer-events]="
                                              childmenu.submenu ||
                                              (isTourOn?.length ? isTourOn[0] : isTourOn)
                                                ? 'none'
                                                : 'auto'
                                            "
                                            routerLinkActive="cssClassName"
                                          >
                                            <i
                                              *ngIf="childmenu.submenu"
                                              [class]="
                                                index === menuItems.length - 1 ||
                                                index === menuItems.length - 2
                                                  ? 'fa fa-angle-left left-icon'
                                                  : 'fa fa-angle-right right-icon'
                                              "
                                            >
                                            </i>
                                            {{ childmenu.text }}
                                          </a>
                                        </ng-template>
                                      </ng-container>

                                      <ul
                                        class="menu-sub-l3 fixed-height-scrollable"
                                        *ngIf="childmenu.submenu && childmenu.isAccess"
                                        [ngStyle]="{
                                          right:
                                            index === menuItems.length - 1 ||
                                            index === menuItems.length - 2
                                              ? '100%'
                                              : 'unset',
                                          left:
                                            index === menuItems.length - 1 ||
                                            index === menuItems.length - 2
                                              ? 'unset'
                                              : '100%'
                                        }"
                                      >
                                        <li *ngFor="let l3Menu of childmenu.submenu">
                                          <div>
                                            <div class="mega-menu-content">
                                              <div class="row">
                                                <div class="col-md-12">
                                                  <ul
                                                    *ngIf="l3Menu.isAccess"
                                                    class="mega-menu-submenu"
                                                  >
                                                    <li>
                                                      <a
                                                        *ngIf="
                                                          getStaticAssetUrl(l3Menu) as pdfUrl;
                                                          else routerLinkAnchor
                                                        "
                                                        class="iconify no-link"
                                                        [href]="pdfUrl"
                                                        target="_blank"
                                                        rel="noopener"
                                                      >
                                                        <i class="{{ l3Menu.icon }}"></i>
                                                        {{ l3Menu.text }}
                                                      </a>
                                                      <ng-template #routerLinkAnchor>
                                                        <a
                                                          class="iconify no-link"
                                                          routerLink="{{ l3Menu.link }}"
                                                          routerLinkActive="cssClassName"
                                                        >
                                                          <i class="{{ l3Menu.icon }}"></i>
                                                          {{ l3Menu.text }}
                                                        </a>
                                                      </ng-template>
                                                    </li>
                                                  </ul>
                                                </div>
                                              </div>
                                            </div>
                                          </div>
                                        </li>
                                      </ul>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            </div>
                          </li>
                        </ng-container>
                      </ul>
                    </li>
                  </ng-container>
                </ul>
              </li>
            </ng-container>
          </ul>
          <button type="button" class="btn btn-dark profilebtn" (click)="OnProfilePage()">
            Profile <i class="bi bi-arrow-right"></i>
          </button>
        </div>
      </div>
    </nav>
  </div>
</ng-container>
